import { useEffect } from 'react';
import { useState } from 'react';
import {
  Modal,
  Button,
  DatePicker,
  Form,
  message,
} from 'antd';
import '../styles/DatePickerStyles.css';
import moment from 'moment';

export const TaskStartDatePickerModal = ({ visible, setVisible, onClose, currentStartDate, disabledDates = true }) => {
  const [isSelecting, setIsSelecting] = useState(false);

  const [form] = Form.useForm();

  const handleDateOk = () => {
    try {
      setVisible(false);
      message.destroy();
      onClose(form.getFieldsValue());
    } catch (error) {
      message.error('Error occurred while validating date:', error);
    }
  };

  useEffect(() => {
    if (currentStartDate) {
      form.setFieldsValue({
        startDate: currentStartDate ? moment(currentStartDate) : null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStartDate]);

  return (
    <>
      <Modal
        closable={false}
        open={visible}
        width={290}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          initialValues={{
            startDate: moment(),
          }}
        >
          <div
            style={{
              height: 330,
              width: 300,
              display: 'flex',
              flexGap: '8px',
            }}
          >
            <div>
              <div style={{ height: 290, width: 300 }}>
                <Form.Item name="startDate" noStyle>
                  <DatePicker
                    open={visible}
                    onChange={() => {
                      setIsSelecting(true);
                      setTimeout(() => setIsSelecting(false), 100);
                    }}
                    onOpenChange={(open) => {
                      if (!open && !isSelecting) {
                        setVisible(false);
                      }
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="task-date-picker"
                    disabledDate={disabledDates ? (current) => {
                      const today = moment().startOf('day');
                      return current && current.isBefore(today, 'day');
                    } : null}
                  />
                </Form.Item>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-start',
                  padding: '8px 12px',
                  width: '100%',
                }}
                onMouseDown={() => setIsSelecting(true)}
                onMouseUp={() => setIsSelecting(false)}
              >
                <Button type="link" onClick={handleDateOk}>
                  Update
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <style>
        {`
          .ant-modal-body {
            padding: 0;
          }
        `}
      </style>
    </>
  );
};
